import { CalculatedDiscount } from '@app-types/api/vapi';
import { DiscountEnumType, DiscountType } from '@app-types/discount';

export class VapiMapper {
    public static discountMapper(discount: CalculatedDiscount): DiscountType {
        return {
            type: VapiMapper.discountTypeMapper(discount.type),
            label: discount.identifiant,
            value: discount.remiseCalculee.remise.montant,
            discount: discount.remiseCalculee.remise.montant,
            duration: discount.remiseCalculee.remise.duree,
            marketingTypes: (discount.caracteristiques ?? [])
                .filter((c) => c.typeCaracteristique === 'marketingTypes')
                .map((c) => c.valeur),
        };
    }

    private static discountTypeMapper(discountType: CalculatedDiscount['type']): DiscountEnumType {
        switch (true) {
            case discountType === 'MONTANT_VARIABLE':
                return DiscountEnumType.VARIABLE_AMOUNT;
            case discountType === 'PROMOTION_COUPON':
                return DiscountEnumType.COUPON;
            case discountType === 'PROMOTION_STANDARD':
            default:
                return DiscountEnumType.STANDARD;
        }
    }
}
